module.exports = __webpack_public_path__ + "static/8-61ff84d52f5566b688f829f243f13bfb.jpg";